if (!customElements.get('aw-product-description')) {
  customElements.define(
    'aw-product-description',
    class AwProductDescription extends HTMLElement {
      connectedCallback() {
        this.clamp = this.querySelector('.aw-product-description__clamp');
        this.toggle = this.querySelector('.aw-product-description__toggle');
        if (!this.clamp || !this.toggle) return;

        requestAnimationFrame(() => {
          const isTruncated = this.clamp.scrollHeight > this.clamp.clientHeight + 1;
          if (!isTruncated) return;

          this.toggle.classList.add('aw-product-description__toggle--visible');
          this.toggle.addEventListener('click', () => this.toggleExpanded());
        });
      }

      toggleExpanded() {
        const isExpanded = this.getAttribute('data-expanded') === 'true';
        this.setAttribute('data-expanded', isExpanded ? 'false' : 'true');
        this.toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');

        if (isExpanded) {
          this.scrollIntoView({ block: 'nearest' });
        }
      }
    }
  );
}
